import Image from "next/image";
import Head from "next/head";
import CookieBanner from "@/components/CookieBanner";
import Footer from "@/components/common/Footer";
import Header from "@/components/common/Header";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

export default function Home() {
  const { locale } = useRouter();
  const { t } = useTranslation("common");
  return (
    <>
      <Head>
        <title>{t("metaTag.fourOfour")}</title>
        <meta name="description" content={t("metaTag.fourOfour")} />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="icon" href={t("metaTag.favicon")} type="image/x-icon" />

        <meta property="og:locale" content="de_DE" />
      </Head>
      <div className="bg-[#F9F9F9]">
        <div>
          <Header />

          <main className="mx-auto max-w-2xl px-4 py-8 sm:px-6 lg:max-w-7xl lg:px-8 lg:py-16">
            <div className="flex flex-col gap-3 h-[1000px]">
              <Image
                src={locale === "de" ? "images/404.svg" : "images/404en.svg"}
                alt={
                  locale === "de"
                    ? "Keine Fotobox gefunden"
                    : "No photo booth found"
                }
                className="w-42 lg:w-[500px] mx-auto"
                width={42}
                height={42}
              />

              <div className="font-bold text-[42px] text-center leading-tight mb-14">
                {locale === "de" ? "Seite nicht gefunden" : "Page not found"}
              </div>

              <a
                href="/"
                className="mx-auto text-center rounded-md bg-[#FF5744] my-2 lg:my-0 px-8 py-2.5 text-[20px] font-semibold text-white shadow-sm hover:bg-[#2C3657] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 max-w-[300px]"
              >
                {locale === "de" ? "Startseite aufrufen" : "Back to start"}
              </a>
            </div>
          </main>

          <Footer />
        </div>
      </div>
      <CookieBanner />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])), // ← "common" Namespace laden
    },
  };
}
